module.exports = __webpack_public_path__ + "img/icon-switch-off.c255c55.svg";